import { cn } from "@/util/functions";

const EventButton = ({ label, number, isActive, isWide, disabled, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-px-1 tw-py-1 tw-h-14 tw-text-sm tw-transition-colors tw-border tw-border-gray-300 tw-bg-white tw-bg-opacity-10",
        isActive
          ? "tw-bg-green-600 tw-text-white"
          : "tw-bg-transparent tw-text-white",
        isWide ? "tw-w-24" : "tw-w-14",
        disabled ? "tw-opacity-50 tw-cursor-not-allowed" : "tw-cursor-pointer"
      )}
      disabled={disabled}
    >
      {number && <span className="tw-text-sm tw-font-semibold">{number}</span>}
      <span className="tw-text-xs tw-break-words tw-text-center tw-w-full">
        {label}
      </span>
    </button>
  );
};

export default EventButton;
